import React, { useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import Swal from "sweetalert2";
import { newsletterService } from "../pages/publicservice/newsletterService";

import "swiper/css";

const instaImages: string[] = [
  "/assets/img/instagram/inssta-1-1.jpg",
  "/assets/img/instagram/inssta-1-2.jpg",
  "/assets/img/instagram/inssta-1-3.jpg",
  "/assets/img/instagram/inssta-1-4.jpg",
  "/assets/img/instagram/inssta-1-5.jpg",
  "/assets/img/instagram/inssta-1-6.jpg",
];

const NewsletterSection: React.FC = () => {

  const [email, setEmail] =
    useState<string>("");

  const [loading, setLoading] =
    useState<boolean>(false);

  const [message, setMessage] =
    useState<string>("");

  const [messageType, setMessageType] =
    useState<"success" | "error" | "">("");

  // =====================================
  // EMAIL VALIDATION
  // =====================================
  const validateEmail = (
    value: string
  ) => {

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      .test(value);
  };

  // =====================================
  // SUBSCRIBE
  // =====================================
  const handleSubscribe = async (
    e: React.FormEvent<HTMLFormElement>
  ) => {

    e.preventDefault();

    // ===============================
    // VALIDATION
    // ===============================
if (!email.trim()) {

 Swal.fire({
  icon: "error",
  title: "Oops...",
  text: "Please enter your email address.",

  confirmButtonText: "Okay",
  showCloseButton: true,

  background: "#ffffff",
  color: "#000",

  confirmButtonColor: "#b8400e",

  customClass: {
    popup: "theme-popup",
    title: "theme-popup-title",
    confirmButton: "theme-popup-btn",
    closeButton: "theme-close-btn",
    icon: "theme-icon",
  },
});

  return;
}
    if (!validateEmail(email)) {

      setMessage(
        "Please enter a valid email address."
      );

      setMessageType("error");

      return;
    }

    try {

      setLoading(true);

      setMessage("");

      const payload = {

        email: email.trim(),

        name: "",

        source: "Website Newsletter",
      };

      const response =
        await newsletterService.create(
          payload
        );

      console.log(
        "Newsletter Response",
        response
      );

      // ===============================
      // SUCCESS
      // ===============================
      if (response?.isSuccess) {

        setMessageType("success");

        setMessage(
          response?.message ||
          "✅ Thank you for subscribing to our newsletter."
        );

        setEmail("");

      } else {

        setMessageType("error");

        setMessage(
          response?.message ||
          "Subscription failed."
        );
      }

    } catch (error: any) {

      console.error(
        "Newsletter Error",
        error
      );

      setMessageType("error");

      setMessage(
        error?.response?.data?.message ||
        "Something went wrong. Please try again."
      );

    } finally {

      setLoading(false);
    }
  };

  return (

    <section className="space-top multi-layout1 z-index-common newsletter-section position-relative overflow-hidden">

      {/* ================================= */}
      {/* SHAPES */}
      {/* ================================= */}

      <img
        src="/assets/img/shapes/ele-m-1-1.svg"
        alt="shape"
        className="ele1 floating"
      />

      <img
        src="/assets/img/shapes/ele-m-1-2.svg"
        alt="shape"
        className="ele2 floating"
      />

      <div className="container-fluid">

        <div className="row">

          <div className="col-md-12">

            {/* ================================= */}
            {/* NEWSLETTER CONTENT */}
            {/* ================================= */}

            <div
              className="col-lg-7 mx-auto wow animate__fadeInUp"
              data-wow-delay="0.2s"
            >

              <div className="newsletter-title text-center mb-40">

                <span className="sec-subtitle">
                  Our Newsletter
                </span>

                <h2 className="sec-title text-white">

                  Get Our Latest Updates

                </h2>

                <p className="sec-text text-dark">

                  Subscribe to receive updates on
                  new arrivals, special offers,
                  and exclusive discounts.

                </p>

              </div>

              {/* ================================= */}
              {/* FORM */}
              {/* ================================= */}

              <form
                className="newsletter-form d-flex flex-column flex-md-row"
                onSubmit={handleSubscribe}
              >

                <div className="w-100 position-relative">

                  <input
                    className="form-control newsletter-input"
                    type="email"
                    name="email"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) =>
                      setEmail(
                        e.target.value
                      )
                    }
                    autoComplete="off"
                  />

                </div>

                <button
                  type="submit"
                  className="vs-btn subscribe-btn"
                  disabled={loading}
                >

                  {
                    loading ? (
                      <>

                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>

                        Subscribing...

                      </>
                    ) : (
                      <>

                        <img
                          src="/assets/img/icons/vs-icon-subscribe-1.svg"
                          alt="subscribe"
                        />

                        Subscribe

                      </>
                    )
                  }

                </button>

              </form>

              {/* ================================= */}
              {/* MESSAGE */}
              {/* ================================= */}

              {message && (

                <div
                  className={`newsletter-message mt-4 text-center ${messageType === "success"
                    ? "success-message"
                    : "error-message"
                    }`}
                >

                  {message}

                </div>

              )}

            </div>

            {/* ================================= */}
            {/* INSTAGRAM SLIDER */}
            {/* ================================= */}

            <div className="mt-5">

              <Swiper
                modules={[Autoplay]}
                className="instagram-swiper"
                spaceBetween={24}
                loop={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  576: {
                    slidesPerView: 2,
                  },
                  768: {
                    slidesPerView: 3,
                  },
                  992: {
                    slidesPerView: 4,
                  },
                  1200: {
                    slidesPerView: 5,
                  },
                }}
              >

                {instaImages.map((img, i) => (

                  <SwiperSlide
                    key={i}
                    className="instagram-slide"
                  >

                    <div
                      className="insta-style wow animate__fadeInUp"
                      data-wow-delay={`${0.2 + i * 0.1
                        }s`}
                    >

                      <img
                        src={img}
                        alt={`instagram-${i}`}
                        className="img-fluid"
                      />

                      <div className="insta-overlay">

                        <a
                          href="https://www.instagram.com/"
                          className="insta-icon"
                          target="_blank"
                          rel="noreferrer"
                        >

                          <i className="fa-brands fa-instagram"></i>

                        </a>

                      </div>

                    </div>

                  </SwiperSlide>

                ))}

              </Swiper>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default NewsletterSection;